import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchCertificatesSummary,
  selectCertificatesSummary,
  selectCertificatesSummaryStatus,
} from 'src/v3/profile/profile.slice'

export function useCertificatesSummary() {
  let dispatch = useAppDispatch()

  let data = useAppSelector(selectCertificatesSummary)
  let status = useAppSelector(selectCertificatesSummaryStatus)

  let isLoading = status === 'pending' || status === 'uninitialized'
  let isError = status === 'rejected'
  let isSuccess = status === 'fulfilled'

  useEffect(() => {
    if (status === 'uninitialized') {
      dispatch(fetchCertificatesSummary())
    }
  }, [status, dispatch])

  return {
    data,
    status,
    isLoading,
    isError,
    isSuccess,
    refetch: () => dispatch(fetchCertificatesSummary()),
  }
}
